import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import a from "classnames";
/* empty css                            */
import s from "../../../../internal/Button/Button.js";
import { ButtonVariant as c } from "../../../../internal/Button/types.js";
import l from "../../../../../core/Context/useCoreContext.js";
import { Icon as d } from "../../../../internal/Icon/Icon.js";
import { Header as p } from "../../../../internal/Header/Header.js";
const b = ({
  children: r,
  className: e,
  headerTitleKey: o,
  headerSubtitleKey: i,
  onDetailsClose: n
}) => {
  const { i18n: m } = l();
  return /* @__PURE__ */ t("div", { className: a("adyen-pe-grant-adjustment-details", e), children: [
    /* @__PURE__ */ t(p, { titleKey: o, subtitleKey: i, children: /* @__PURE__ */ t(
      s,
      {
        onClick: n,
        variant: c.TERTIARY,
        iconButton: !0,
        classNameModifiers: ["circle"],
        "aria-label": m.get("dismiss"),
        children: /* @__PURE__ */ t(d, { name: "cross" })
      }
    ) }),
    r
  ] });
};
export {
  b as GrantAdjustmentDetails
};
